import React from "react";

export const QueerAffirmativeSection = () => {
  return (
    <section className="py-20 px-6 relative overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: "url(/assets/home-queer-affirmative-background.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.2,
        }}
      />

      <div className="max-w-4xl mx-auto relative z-10">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-gray-800 mb-4">
          Queer affirmative therapy
        </h2>

        <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-2xl mt-12">
          <p className="text-lg text-gray-700 leading-relaxed">
            Being queer in a world that often questions or ignores your identity
            can be exhausting. I believe in the power of community, and its
            sense of belonging and empathy that helps us breathe a little
            easier. In therapy, I try to create that kind of space: a room where
            you don't have to pretend or hide who you are. Here, you can show up
            as yourself, unapologetically. I want to hold space for the joys,
            questions, struggles, and everyday realities that come with queer
            lives.
          </p>
        </div>
      </div>
    </section>
  );
};
